<!-- OrderDetailBody.vue -->
<template>
    <div class="order-deliver">
        <div class="common-header-wrap">
            <mt-header title="物流查询" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="main-content">
            <flex-line :show-border="true"><span class="line-name">物流公司</span><span slot="right">{{express_name}}</span></flex-line>
            <flex-line :show-border="true"><span class="line-name">物流单号</span><span slot="right">{{shipping_code}}</span></flex-line>

        <div class="mt-5" v-if="deliver_info">
            <flex-line v-for="(item,index) in deliver_info" :key="index" :show-border="true"><span class="line-name">{{item.AcceptTime}}</span><span slot="right">{{item.AcceptStation}}</span></flex-line>
        </div>
        </div>
    </div>
</template>

<script>

import { Toast, MessageBox } from 'mint-ui'
import { getOrderDeliver } from '../../../api/memberOrder'
import flexLine from '../../flexLine'
export default {
  name: 'MemberOrderDeliver',
  data () {
    return {
        deliver_info: false,
        express_name:'',
        shipping_code:''
    }
  },
  components:{
    flexLine
  },

  created: function () {
    if (this.$route.query.order_id) {
        getOrderDeliver(this.$route.query.order_id).then(res => {
        this.deliver_info = res.result.deliver_info
            this.express_name=res.result.express_name
            this.shipping_code=res.result.shipping_code
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },

  methods: {

  }
}
</script>
<style lang="scss" scoped>
.main-content{background: #fff;padding:0 $pageSpace}
</style>

